import { defineComponent as _defineComponent } from 'vue'
import { useBulkAssignMutation } from '@/api/jobs'
import AssignmentField from '../common/AssignmentField.vue'
import BulkUpdateWrapper from '../common/BulkUpdateWrapper.vue'
import TicketUnitNumberCrew from '../tickets/TicketUnitNumberCrew.vue'
import { useStore } from 'vuex-composition-helpers'
import { computed, ref } from 'vue'
import { JobJson } from '@/models/types/job-json'
import { UnitNumber } from '@/models/unit_number'
import { BulkUpdateResponse } from '@/models/types/bulk-update-response'


export default /*#__PURE__*/_defineComponent({
  __name: 'BulkAssignForm',
  props: {
    buttonLabel: null,
    selectedJobs: null
  },
  emits: ["dismiss", "updated"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'dismiss')
  (e: 'updated', { message, updatedJobs }: BulkUpdateResponse)
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  buttonLabel: string
  selectedJobs: JobJson[]
}

const store = useStore()
const getResourceById = computed<(id: number) => UnitNumber>(
  () => store.getters['unitNumbers/getById']
)





const showSnackBar = ref(false)
const assignedResourceId = ref<number | null>()
const assignedServiceProviderId = ref<string | null>()
const assignedOperators = ref<string[] | null>()

const { bulkAssign, isLoading: saving, isError } = useBulkAssignMutation()

const hubId = computed<string>(() => {
  return props.selectedJobs[0].hub_id
})
const resourceTypeId = computed<number>(() => {
  return props.selectedJobs[0].resource_type_id
})

const hasChanges = computed<boolean>(() => {
  return (
    assignedResourceId.value !== null ||
    assignedServiceProviderId.value !== null
  )
})

const clearSnackbar = () => (showSnackBar.value = false)
const dismiss = () => emits('dismiss')

const handleInput = (value) => {
  if (value === null) {
    assignedResourceId.value = null
    assignedServiceProviderId.value = null
    assignedOperators.value = []
    return
  }

  const [type, id] = value.split('__')
  if (type === 'resource') {
    assignedResourceId.value = parseInt(id)
    assignedServiceProviderId.value = null
  } else {
    assignedServiceProviderId.value = id
    assignedResourceId.value = null
  }
}

const updateOperators = (value) => {
  assignedOperators.value = value
}

const save = async () => {
  try {
    await bulkAssign({
      jobIds: props.selectedJobs.map((job) => job.id),
      resourceId: assignedResourceId.value,
      serviceProviderId: assignedServiceProviderId.value,
      operators: assignedOperators.value,
    })
    const updatedJobs: JobJson[] = props.selectedJobs.map(({ ...job }) =>
      Object.assign(job, {
        assigned_resource_id: assignedResourceId.value,
        assigned_service_provider_id: assignedServiceProviderId.value,
      })
    )
    emits('updated', { message: 'Assignment updated', updatedJobs })
  } catch (e) {
    showSnackBar.value = isError.value
  }
}

const resourceOwner = computed(() => {
  if (!assignedResourceId.value) {
    return null
  }
  return getResourceById.value(assignedResourceId.value)?.organizationId
})

return { __sfc: true,store, getResourceById, emits, props, showSnackBar, assignedResourceId, assignedServiceProviderId, assignedOperators, bulkAssign, saving, isError, hubId, resourceTypeId, hasChanges, clearSnackbar, dismiss, handleInput, updateOperators, save, resourceOwner, AssignmentField, BulkUpdateWrapper, TicketUnitNumberCrew }
}

})